import React, { Component } from 'react'
import { connect } from 'react-redux'
import { InfoWindow } from 'react-google-maps'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import isEmpty from 'lodash.isempty'
import { Button } from '@material-ui/core'
import { onCloseMarkerInfo, setActiveMap } from 'reducers/seaLice/reducer'
import {
  FILTER_LIST_VIEW,
  LIST_VIEW_MY_SITES,
  TYPE_FEMALES,
  TYPE_ADULTS,
  TYPE_JUVENILES,
} from 'helpers/seaLice'

import messages from '../../translate'

class MarkerInfo extends Component {
  static propTypes = {
    activeMarker: PropTypes.object.isRequired,
  }

  onCloseInfo = () => {
    this.props.onCloseMarkerInfo()
  }

  onViewMoreClick = () => {
    this.props.setActiveMap(FILTER_LIST_VIEW)
  }

  parseInfoLabel = label => {
    const {
      intl: { formatMessage },
    } = this.props

    switch (label) {
      case TYPE_FEMALES:
        return formatMessage(messages.gravidFemales)
      case TYPE_ADULTS:
        return formatMessage(messages.mobileAdults)
      case TYPE_JUVENILES:
        return formatMessage(messages.juvenile)
      default:
        return formatMessage(messages.totalSeaLice)
    }
  }

  render() {
    const {
      activeMarker,
      activeType,
      intl: { formatMessage },
      activeView,
    } = this.props
    const { position, marker } = activeMarker
    const typeData = marker ? marker.weeks[5][activeType] : null

    if (isEmpty(activeMarker)) {
      return null
    }

    return (
      <InfoWindow
        position={position.latLng}
        onCloseClick={this.onCloseInfo}
        options={{
          pixelOffset: new window.google.maps.Size(0, -48),
        }}>
        <div className="info-window">
          <h5>{marker.site_name ? marker.site_name : marker.siep}</h5>
          <h6>
            {this.parseInfoLabel(activeType)}: {typeData || 'N/A'}
          </h6>
          {activeView === LIST_VIEW_MY_SITES && (
            <Button variant="contained" onClick={this.onViewMoreClick}>
              {formatMessage(messages.view_more)}
            </Button>
          )}
        </div>
      </InfoWindow>
    )
  }
}

export default connect(
  state => ({
    activeMarker: state.getIn(['seaLice', 'markerParams']).toJS(),
    activeType: state.getIn(['seaLice', 'activeType']),
    activeView: state.getIn(['seaLice', 'activeView']),
  }),
  {
    onCloseMarkerInfo,
    setActiveMap,
  },
)(injectIntl(MarkerInfo))
